import { styled } from "@mui/material";
import { exProps } from "utils/mui";

export const BlockContainer = styled('div', exProps('selected', 'showProps'))
  <{ selected?: boolean, showProps?: boolean }>(({ theme, selected, showProps }) => ({

  width: 230,
  minHeight: 80,
  position: "absolute",
  boxShadow: `0px 2px 10px rgba(0, 0, 0, 0.2)`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid transparent`,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  userSelect: "none",
  ...selected && {
    borderColor: theme.palette.primary.main,
  },
  ".block-info": {
    opacity: 0,
    transform: `translateY(-20px) scale(0.9)`,
    transition: theme.transitions.create([ 'opacity', 'transform' ], { duration: 150 }),
    pointerEvents: "none",
    ...showProps && {
      opacity: 1,
      transform: `translateY(0px) scale(1)`,
      pointerEvents: "all"
    }
  }
}))

export const BlockKey = styled('div')(({ theme }) => ({
  position: "absolute",
  top: -20,
  whiteSpace: "nowrap",
  fontFamily: "Noto Sans Mono, monospace",
  fontSize: 11
}))

export const BlockHeader = styled('div')(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: theme.spacing(1)
}))

export const BlockTitle = styled('div')(({ theme }) => ({
  
}))

export const BlockContent = styled('div')(({ theme }) => ({
  display: "flex",
  flexDirection: "column"
}))

export const BlockChainEmitters = styled('div')(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  marginTop: theme.spacing(1)
}))

export const BlockInfoContainer = styled('div')(({ theme }) => ({
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  marginTop: 14,
  padding: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  boxShadow: `0px 2px 10px rgba(0, 0, 0, 0.2)`,
  zIndex: 10,
  border: `1px solid ${theme.palette.divider}`,
  "&>svg": {
    position: "absolute",
    bottom: "100%",
    left: "50%",
    color: theme.palette.background.paper,
    transform: `translateX(-50%)`
  }
}))